import BlockRegistry from '../../BlockRegistry';

const stripQuotes = (str) => {
    if (typeof str === 'string' && str.startsWith('"') && str.endsWith('"')) {
        return str.slice(1, -1);
    }
    return str;
};

export function registerLEDActuator() {
    BlockRegistry.register('ledActuator_led_setDigital', (block, context) => {
        let pin = context.getInputValue(block, 'PIN') || context.getFieldValue(block, 'PIN');
        let state = context.getInputValue(block, 'STATE') || context.getFieldValue(block, 'STATE');
        
        pin = stripQuotes(pin);
        state = stripQuotes(state);

        context.addSetup(`pinMode(${pin}, OUTPUT);`);
        return `digitalWrite(${pin}, ${state})`;
    });

    BlockRegistry.register('ledActuator_led_setPWM', (block, context) => {
        let pin = context.getInputValue(block, 'PIN') || context.getFieldValue(block, 'PIN');
        let pwm = context.getInputValue(block, 'PWM') || context.getFieldValue(block, 'PWM');
        
        pin = stripQuotes(pin);
        pwm = stripQuotes(pwm);

        context.addSetup(`pinMode(${pin}, OUTPUT);`);
        return `analogWrite(${pin}, ${pwm})`;
    });
}
